import CatalogSearchBar from "./CatalogSearchBar";

export default CatalogSearchBar;
